import { useState, useRef, useEffect } from "react";
import "../styles/ListObjectActionsMenu.css"; // Assurez-vous d'importer le fichier CSS

function ListActionsMenu({ onRename, onShare, onDelete }) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef();

  // console.log("onRename prop is", typeof onRename);

  const handleClickOutside = (e) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleRename = () => {
    setOpen(false);
    onRename();
  };

  const handleShare = () => {
    setOpen(false);
    onShare();
  };

  const handleDelete = () => {
    setOpen(false);
    onDelete();
  };

  return (
    <div className="kdo_menu" ref={menuRef}>
      <button className="kdo_menu_button" onClick={() => setOpen(!open)}>
        {/* ⋯ */}
         <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="5" cy="12" r="2" />
            <circle cx="12" cy="12" r="2" />
            <circle cx="19" cy="12" r="2" />
        </svg>
      </button>
      {open && (
        <div className="kdo_menu_popup">
          <div className="kdo_menu_item" onClick={handleRename}>✏️ Renommer</div>
          <div className="kdo_menu_item" onClick={handleShare}>🔗 Partager</div>
          <div className="kdo_menu_item" onClick={handleDelete}>🗑️ <span>Supprimer</span></div>
        </div>
      )}
    </div>
  );
}

export default ListActionsMenu;
